module.exports = __webpack_public_path__ + "img/project.76ce5d59.jpg";